<ion-header>
  <ion-toolbar>
    <ion-title>{{ (isEditMode ? 'EDIT_OFFER' : 'ADD_NEW_OFFER') | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form #offerForm="ngForm" (ngSubmit)="openSaveConfirmModal()">
    <ion-list>
      <ion-item>
        <ion-input label="{{ 'TITLE' | translate }}" labelPlacement="floating" required [(ngModel)]="currentItem.title"
          name="title"></ion-input>
      </ion-item>
      <ion-item>
        <ion-textarea label="{{ 'DESCRIPTION' | translate }}" [autoGrow]="true" rows="6" labelPlacement="floating"
          required [(ngModel)]="currentItem.description" name="description" [autoGrow]="true"></ion-textarea>
      </ion-item>
      <ion-item>
        <ion-select label="{{ 'WORK_PACKAGE' | translate }}" [formControl]="workPackageControl" multiple="true"
          required>
          <ion-select-option *ngFor="let wp of availableWorkPackage | filterAll" [value]="wp.value">
            {{wp.name | translate}}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-select label="{{ 'OPPORTUNITY_CATEGORY' | translate }}" required [(ngModel)]="currentItem.action"
          name="action">
          <ion-select-option *ngFor="let action of getFilteredActions() | filterAll" [value]="action.value">
            {{ action.name | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-select label="{{ 'OPPORTUNITY_TYPE' | translate }}" required [(ngModel)]="currentItem.opportunityType"
          name="opportunityType">
          <ion-select-option value="looking-for">{{ 'LOOKING_FOR' | translate }}</ion-select-option>
          <ion-select-option value="offer">{{ 'OFFER' | translate }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ng-container *ngIf="isAdmin(); else readOnlyAffiliation">
          <ion-select label="{{ 'AFFILIATION' | translate }}" required [(ngModel)]="currentItem.affiliation"
            name="affiliation">
            <ion-select-option *ngFor="let aff of filteredAffiliations" [value]="aff.value">
              {{ aff.name | translate }}
            </ion-select-option>
          </ion-select>
        </ng-container>
        <ng-template #readOnlyAffiliation>
          <ion-input label="{{ 'AFFILIATION' | translate }}"
            [value]="getAffiliationName(currentItem.affiliation) | translate" readonly></ion-input>
        </ng-template>
      </ion-item>
      <ion-item>
        <ion-select label="{{ 'FOCUS_AREAS' | translate }}" [formControl]="focusAreasControl" multiple="true" required>
          <ion-select-option *ngFor="let area of availableFocusAreas" [value]="area.value">
            {{ area.name | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-input type="datetime-local" label="{{ 'EXPIRY_DATE' | translate }}" labelPlacement="floating"
          [min]="dateService.getCurrentDateTime()" [(ngModel)]="displayExpirationDate"
          (ionChange)="onDisplayDateChange($event)" name="expirationDate" required>
        </ion-input>
      </ion-item>
      <ion-item button="true" (click)="openCountryModal()" class="ion-margin-top">
        <ion-label class="ion-text-nowrap" style="display: flex; align-items: center;">
          {{ 'COUNTRY' | translate }}
          <ion-icon name="information-circle-outline" class="ion-margin-start" color="medium"
            (click)="showCountryInfo($event)"></ion-icon>
        </ion-label>
        <ion-note slot="end">{{ selectedCountry?.name || ('CLICK_TO_SELECT_COUNTRY' | translate) }}</ion-note>
      </ion-item>
      <ion-item>
        <ion-select label="{{ 'FIELD_OF_SCIENCE' | translate }}" [(ngModel)]="currentItem.fieldOfScience"
          name="fieldOfScience">
          <ion-select-option *ngFor="let field of availableFieldsOfScience | filterAll" [value]="field.value">
            {{ field.name | translate }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item lines="none">
        <ion-input label="{{ 'HEADCOUNT' | translate }}" type="number" placeholder="{{ 'ENTER_HEADCOUNT' | translate }}"
          [disabled]="isHeadcountUnlimited" [ngModel]="currentItem.headcount" (ionChange)="onHeadcountChange($event)"
          name="headcount"></ion-input>
      </ion-item>
      <ion-item>
        <ion-checkbox [(ngModel)]="isHeadcountUnlimited" [ngModelOptions]="{standalone: true}"
          slot="start"></ion-checkbox>
        <ion-label>{{ 'UNLIMITED' | translate }}</ion-label>
      </ion-item>
      <ion-item>
        <ion-checkbox [(ngModel)]="currentItem.isCv" name="isCv" slot="start"></ion-checkbox>
        <ion-label>{{ 'CV_REQUIRED' | translate }}</ion-label>
      </ion-item>
      <ion-list-header>{{ 'CONTACT_EMAILS' | translate }}</ion-list-header>
      <ion-item *ngFor="let email of tempEmailValues; let i = index">
        <ion-input type="email" label="{{'EMAIL'|translate}} {{i+1}}" labelPlacement="floating" required
          [ngModel]="email" (ionChange)="onEmailInput(i, $event)" name="email_{{i}}"
          [class.ion-invalid]="!isValidEmail(email) && offerForm.controls['email_'+i]?.touched">
        </ion-input>
        <ion-button fill="clear" (click)="removeEmail(i)" [disabled]="currentItem.contactEmails.length === 1" slot="end"
          color="danger">
          <ion-icon name="trash" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-item>
      <ion-button expand="full" fill="clear" (click)="addNewEmail()">
        <ion-icon name="add" slot="start"></ion-icon>
        {{ 'ADD_NEW_EMAIL' | translate }}
      </ion-button>
      <ion-list-header>{{ 'REQUIRED_DOCUMENTS' | translate }}</ion-list-header>
      <div *ngFor="let docType of getDocumentTypes()" class="document-item ion-padding">
        <ion-item>
          <ion-select label="{{ 'DOCUMENT_TYPE' | translate }}" [ngModel]="docType"
            (ionChange)="updateDocumentType(docType, $event)" [ngModelOptions]="{standalone: true}">
            <ion-select-option *ngFor="let doc of availableDocuments" [value]="doc.value"
              [disabled]="getDocumentTypes().includes(doc.value) && doc.value !== docType">
              {{ doc.name | translate }}
            </ion-select-option>
          </ion-select>
          <ion-button slot="end" fill="clear" color="danger" (click)="removeDocument(docType)">
            <ion-icon name="trash" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-item>
        <ion-item *ngIf="docType.startsWith('other')">
          <ion-input label="{{ 'ENTER_DOCUMENT_NAME' | translate }}" [value]="getCustomDocumentName(docType)"
            (ionChange)="updateCustomDocumentName(docType, $event)"></ion-input>
        </ion-item>
        <ion-list>
          <ion-item *ngFor="let format of availableFormats">
            <ion-checkbox [checked]="isFormatSelected(docType, format.value)"
              (ionChange)="toggleFormat(docType, format.value, $event)" slot="start"></ion-checkbox>
            <ion-label>{{ format.name }}</ion-label>
          </ion-item>
        </ion-list>
      </div>
      <ion-button expand="full" fill="clear" (click)="addNewDocument()"
        [disabled]="getDocumentTypes().length >= availableDocuments.length">
        <ion-icon name="add" slot="start"></ion-icon>
        {{ 'NEW_UPLOAD_METHOD' | translate }}
      </ion-button>
    </ion-list>
  </form>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closeModal()">{{ 'CANCEL' | translate }}</ion-button>
    </ion-buttons>
    <ion-buttons style="margin: 0 auto;">
      <ion-button color="danger" (click)="confirmDelete()" *ngIf="isEditMode">
        <ion-icon name="trash"></ion-icon>
        {{ 'DELETE' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="openSaveConfirmModal()" [disabled]="!isFormValid">{{ 'SAVE' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>